/**
 * useJournalShortcut — global keyboard shortcut to reveal the hidden Journal.
 *
 * Shortcut: Ctrl+Shift+J (Windows/Linux) or Cmd+Shift+J (macOS).
 *
 * When pressed:
 * - reveals the Journal (shows the PIN lock gate), and
 * - switches the active module to 'journal' so the gate is rendered.
 *
 * Pressing Escape while the Journal is revealed hides and re-locks it.
 */

import { useEffect } from 'react';
import { useUIStore } from '@/stores/uiStore';
import { useJournalLockStore } from '@/stores/journalLockStore';

export function useJournalShortcut(): void {
  const setActiveModule = useUIStore((s) => s.setActiveModule);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const mod = e.ctrlKey || e.metaKey;
      // Reveal: Ctrl/Cmd + Shift + J
      if (mod && e.shiftKey && (e.key === 'J' || e.key === 'j')) {
        e.preventDefault();
        const lock = useJournalLockStore.getState();
        void lock.initialize().finally(() => {
          useJournalLockStore.getState().reveal();
          setActiveModule('journal');
        });
        return;
      }

      // Hide + re-lock: Escape while revealed.
      if (e.key === 'Escape') {
        const { revealed, hide } = useJournalLockStore.getState();
        if (revealed) {
          hide();
        }
      }
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [setActiveModule]);
}
